import { create } from "zustand";
import { createJSONStorage, type PersistOptions } from "zustand/middleware";
import { keyTheme } from "./StoreNames.ts";
import { persist } from "zustand/middleware";
import { useStore } from "zustand/index";
import {
  darkThemeConfig,
  lightThemeConfig,
} from "../styles/AntdThemeConfig.ts";

export const THEMES_MAP = { light: lightThemeConfig, dark: darkThemeConfig };
type ThemeKeys = keyof typeof THEMES_MAP;
const DEFAULT_THEME: ThemeKeys = "light";

interface AntdThemeConfigStore {
  themeKey: ThemeKeys;
  switchTheme: (key: ThemeKeys) => void;
  getTheme: () => keyof typeof THEMES_MAP;
}

const persistOptions: PersistOptions<AntdThemeConfigStore> = {
  storage: createJSONStorage<AntdThemeConfigStore>(() => localStorage),
  name: keyTheme,
};

const ThemeStore = create<AntdThemeConfigStore>()(
  persist(
    (set, get) => ({
      themeKey: DEFAULT_THEME,
      switchTheme: (key: ThemeKeys) => {
        set({ themeKey: key });
      },
      getTheme: () => get().themeKey,
    }),
    persistOptions,
  ),
);

const getSwitchedTheme = () => {
  return ThemeStore.getState().getTheme() === "light" ? "dark" : "light";
};

const useThemeStore = () => {
  return useStore(ThemeStore);
};

export { getSwitchedTheme, useThemeStore };
